import { visserApi } from "./visserApi";
const getAllArticleGroups = async () => {
    return await visserApi.get('ArticleGroup/GetAll');
};
const articleGroupApi = {
    getAllArticleGroups
};
export default articleGroupApi;
